export default __webpack_public_path__ + "static/media/gallery-wip-crystal-chamber_00.0e04d6fc.jpg";